import { DEFAULTS } from "./consts";
import { IMAGE_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/node-view-renderers-loadable";
const pluginImage = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: IMAGE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginImage
};
//# sourceMappingURL=viewer-loadable.js.map
